import { IGetRegionResponseSchema } from '../../../repositories/monolith-python/entities/schemas/GetRegionResponseSchema';
import { ISelectOption } from '@cian/ui-kit/prev/select';

/**
 * Формирует опции селектора для филда Регион
 */
export const getRealtorRatingRegionFieldOptions = (regionItems: IGetRegionResponseSchema[]): ISelectOption[] => {
  return [
    { value: 0, label: 'Любой' },
    ...regionItems.map(({ id, displayName }) => ({ value: id, label: displayName })),
  ];
};
